import { render } from "./RatingIndex.vue?vue&type=template&id=7a6a3cda&scoped=true"
import script from "./RatingIndex.vue?vue&type=script&lang=js"
export * from "./RatingIndex.vue?vue&type=script&lang=js"

import "./RatingIndex.vue?vue&type=style&index=0&id=7a6a3cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6a3cda"]])

export default __exports__